/* eslint-disable @next/next/no-img-element */
import { Suspense, useMemo } from 'react';

import { Skeleton } from './skeleton';

export type ImageServerProps = {
  ref?: React.RefObject<HTMLImageElement | null>;
  format?: 'webp' | 'jpg' | 'png';
  useRetina?: boolean;
  fill?: boolean;
  quality?: number;
} & React.ImgHTMLAttributes<HTMLImageElement>;

const ImageServer: React.FC<ImageServerProps> = ({
  src,
  alt,
  quality = 77,
  format = 'webp',
  useRetina = true,
  width,
  ...props
}) => {
  const baseWidth = Math.min(Number(width) || 800, 1400);
  const ctfWidth = Math.min(Number(width) || 475, 1400);

  const url = useMemo(() => {
    const hasQuery = src?.includes('?');
    const srcParamsSeparator = hasQuery ? '&' : '?';

    if (typeof src === 'string' && src?.includes('ctfassets')) {
      return `${src}${srcParamsSeparator}q=${quality}&w=${!!useRetina ? Number(ctfWidth) * 2 : ctfWidth}&fm=${format}`;
    }

    if (typeof src === 'string') {
      return `${src}${srcParamsSeparator}quality=${quality}&width=${!!useRetina ? Number(baseWidth) * 2 : baseWidth}&format=${format}`;
    }

    return '';
  }, [src, quality, format, baseWidth, ctfWidth, useRetina]);

  if (!src) {
    return null;
  }

  return (
    <Suspense fallback={<Skeleton className={`h-full w-full ${props.className}`} />}>
      <img src={url || src} alt={alt} {...props} />
    </Suspense>
  );
};

export default ImageServer;
